import { namespacer } from "util/namespace";
import { TW_API_URL } from "config";

const NAMESPACE = "PAGES_PLAYERS";

export const GET_PLAYERS_REQUEST_START = namespacer(
  NAMESPACE,
  "GET_PLAYERS_REQUEST_START"
);
export const GET_PLAYERS_REQUEST_SUCCESS = namespacer(
  NAMESPACE,
  "GET_PLAYERS_REQUEST_SUCCESS"
);
export const GET_PLAYERS_REQUEST_ERROR = namespacer(
  NAMESPACE,
  "GET_PLAYERS_REQUEST_ERROR"
);

export function getPlayersRequestStart() {
  return {
    type: GET_PLAYERS_REQUEST_START,
  };
}

export function getPlayersRequestSuccess(divisions) {
  return {
    type: GET_PLAYERS_REQUEST_SUCCESS,
    divisions,
  };
}

export function getPlayersRequestError(error) {
  return {
    type: GET_PLAYERS_REQUEST_ERROR,
    error,
  };
}

export function getPlayersRequest(season) {
  return (dispatch) => {
    dispatch(getPlayersRequestStart());

    const url = `${TW_API_URL}/twl/stats?season=${season}`;

    return fetch(url)
      .then((data) => data.json())
      .then((divisions) => {
        dispatch(getPlayersRequestSuccess(divisions));
      })
      .catch((error) => {
        dispatch(getPlayersRequestError(error));
      });
  };
}



// WEBPACK FOOTER //
// ./src/actions/pages/players.js